// Navbar & Footer çevirileri (Faz 1).
export const COMMON_I18N = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      corporate: "Kurumsal Çözümler",
      tasFlow: "TAS Flow",
      drAi: "DR AI ile Üret",
      projects: "Projeler",
      about: "Hakkımızda",
      blog: "Blog",
      contact: "İletişim",
      badgeNew: "YENİ",
      portal: "Portal Girişi",
      request: "Talebim Var",
      menuAria: "Menüyü aç/kapat",
    },
    footer: {
      about:
        "Kurumsal yazılım, yapay zekâ, otomasyon ve dijital dönüşüm çözümleri. Şirketinizin işleyişini yazılıma dönüştürüyoruz.",
      colSolutions: "Kurumsal Çözümler",
      solutions: ["Kurumsal Yazılım", "B2B Sistemleri", "ERP / CRM", "AI Agent Otomasyon", "API Entegrasyonları"],
      colCompany: "Dijital Roket",
      company: ["Hakkımızda", "Başarı Hikâyeleri", "Teknolojimiz", "İçgörüler", "İletişim"],
      colContact: "İletişim",
      colLegal: "Yasal",
      legal: ["KVKK", "Gizlilik Politikası", "Çerez Politikası"],
      rights: "© 2026 Dijital Roket. Tüm hakları saklıdır.",
      tagline: "Kurumsal Yazılım · Üretken Yapay Zekâ · Otomasyon · Dijital Dönüşüm",
    },
  },
  en: {
    nav: {
      home: "Home",
      corporate: "Enterprise Solutions",
      tasFlow: "TAS Flow",
      drAi: "Build with DR AI",
      projects: "Case Studies",
      about: "About Us",
      blog: "Blog",
      contact: "Contact",
      badgeNew: "NEW",
      portal: "Client Login",
      request: "Start a Project",
      menuAria: "Open/close menu",
    },
    footer: {
      about:
        "Enterprise software, artificial intelligence, automation and digital transformation solutions. We turn the way your company works into software.",
      colSolutions: "Enterprise Solutions",
      solutions: ["Enterprise Software", "B2B Systems", "ERP / CRM", "AI Agent Automation", "API Integrations"],
      colCompany: "Dijital Roket",
      company: ["About Us", "Success Stories", "Our Technology", "Insights", "Contact"],
      colContact: "Contact",
      colLegal: "Legal",
      legal: ["Data Protection (KVKK)", "Privacy Policy", "Cookie Policy"],
      rights: "© 2026 Dijital Roket. All rights reserved.",
      tagline: "Enterprise Software · Generative AI · Automation · Digital Transformation",
    },
  },
};
